document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".tabs-wrapper .tab");
  const contents = document.querySelectorAll(".tabs-wrapper .content_wrapper");

  if (tabs.length > 0 && contents.length > 0) {
    const firstTabValue = tabs[0].getAttribute("data-tab");

    tabs.forEach(tab => {
      if (tab.getAttribute("data-tab") === firstTabValue) {
        tab.classList.add("active");
      }
    });

    contents.forEach(content => {
      if (content.getAttribute("data-tab") === firstTabValue) {
        content.classList.add("active");
      }
    });

    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        const tabValue = this.getAttribute("data-tab");
        tabs.forEach((t) => t.classList.remove("active"));
        contents.forEach((c) => c.classList.remove("active"));

        tabs.forEach((t) => {
          if (t.getAttribute("data-tab") === tabValue) {
            t.classList.add("active");
          }
        });

        contents.forEach((content) => {
          if (content.getAttribute("data-tab") === tabValue) {
            content.classList.add("active");
          }
        });
      });
    });
  }

  setTimeout(() => {
    document.querySelectorAll('variant-selects .product-form__input').forEach(group => {
      const taggedLabel = group.querySelector('label .option-value-custom-tag');

      if (!taggedLabel) return;

      const label = taggedLabel.closest('label');
      if (!label) return;

      const input = document.getElementById(label.getAttribute('for'));

      if (input && !input.checked) {
        input.click();
      }
    });
  }, 200);
});

(() => {
  const PRODUCT_SELECTOR = '.product__info-container';
  const PICKER_SELECTOR = '[data-quantity-discount-picker]';
  const OPTION_SELECTOR = '[data-quantity-discount-option]';
  const QUANTITY_SELECTOR = '.quantity__input';
  const STICKY_QUANTITY_SELECTOR = '#shopify-section-sticky-atc input#Quantity-sticky-atc';

  let lastQuantity = null;
  let lastQuantityInput = null;
  let lastStickyQuantity = null;
  let lastStickyQuantityInput = null;
  let syncTimer = null;
  let isSyncingQuantity = false;

  const getProductContainer = () => {
    return document.querySelector(PRODUCT_SELECTOR);
  };

  const getPicker = () => {
    const productContainer = getProductContainer();
    if (!productContainer) return null;

    return productContainer.querySelector(PICKER_SELECTOR);
  };

  const getQuantityInput = () => {
    const productContainer = getProductContainer();
    if (!productContainer) return null;

    return productContainer.querySelector(QUANTITY_SELECTOR);
  };

  const getStickyQuantityInput = () => {
    return document.querySelector(STICKY_QUANTITY_SELECTOR);
  };

  const getOptions = picker => {
    if (!picker) return [];

    return [
      ...picker.querySelectorAll(OPTION_SELECTOR)
    ];
  };

  const setQuantity = (input, quantity) => {
    if (!input || !quantity) return;

    if (Number(input.value) === quantity) return;

    input.value = quantity;
    input.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  };

  const syncMainToSticky = quantity => {
    const stickyQuantityInput = getStickyQuantityInput();
    if (!stickyQuantityInput) return;

    if (Number(stickyQuantityInput.value) === quantity) return;

    isSyncingQuantity = true;

    setQuantity(stickyQuantityInput, quantity);

    lastStickyQuantityInput = stickyQuantityInput;
    lastStickyQuantity = quantity;

    isSyncingQuantity = false;
  };

  const syncStickyToMain = quantity => {
    const quantityInput = getQuantityInput();
    if (!quantityInput) return;

    if (Number(quantityInput.value) === quantity) return;

    isSyncingQuantity = true;

    setQuantity(quantityInput, quantity);

    lastQuantityInput = quantityInput;
    lastQuantity = quantity;

    isSyncingQuantity = false;
  };

  const updateQuantityDiscountPrices = variantSelects => {
    if (!variantSelects) return;

    const selectedVariantElement = variantSelects.querySelector('script[data-selected-variant]');
    if (!selectedVariantElement) return;

    const picker = document.querySelector('.product__info-container [data-quantity-discount-picker]');
    if (!picker) return;

    let selectedVariant;
    try {
      selectedVariant = JSON.parse(
        selectedVariantElement.textContent.trim()
      );
    } catch (error) {
      return;
    }

    const basePrice = Number(selectedVariant?.price) || 0;
    if (!basePrice) return;

    const options = [
      ...picker.querySelectorAll('[data-quantity-discount-option]')
    ];

    options.forEach(option => {
      const quantity = Number(option.dataset.quantity) || 0;
      const discount = Number(option.dataset.discount) || 0;
      if (!quantity) return;

      const baseTotal = basePrice * quantity;
      const discountAmount = discount > 0 ? Math.round(baseTotal * discount / 100) : 0;
      const discountedTotal = baseTotal - discountAmount;
      const unitPrice = Math.round(discountedTotal / quantity);

      option.dataset.basePrice = basePrice;
      option.dataset.price = discountedTotal;
      option.dataset.unitPrice = unitPrice;

      const priceElement = option.closest('.quantity-discount-option-wrapper')?.querySelector('[data-quantity-discount-price]');

      if (priceElement) {
        priceElement.textContent = window.formatQuantityDiscountMoney ? window.formatQuantityDiscountMoney(discountedTotal) : discountedTotal;
      }
    });

    const quantityInput = getQuantityInput();
    if (quantityInput) {
      updateQuantityDiscountSelection(quantityInput);
    }
  };

  const updateQuantityDiscountSelection = quantityInput => {
    if (!quantityInput) return;

    const picker = getPicker();
    if (!picker) return;

    const quantity = Number(quantityInput.value) || 0;
    const options = getOptions(picker);
    const details = picker.querySelector('[data-quantity-discount-details]');

    if (!options.length || !quantity || !details) return;

    const lastOption = options.reduce((highest, option) => {
      const optionQuantity = Number(option.dataset.quantity) || 0;

      if (!highest) return option;

      const highestQuantity = Number(highest.dataset.quantity) || 0;

      return optionQuantity > highestQuantity ? option : highest;
    }, null);

    const lastQuantity = lastOption
      ? Number(lastOption.dataset.quantity) || 0
      : 0;

    let activeOption = options.find(option => {
      return Number(option.dataset.quantity) === quantity;
    });

    if (!activeOption && quantity > lastQuantity) {
      activeOption = lastOption;
    }

    options.forEach(option => {
      const optionQuantity = Number(option.dataset.quantity) || 0;

      option.checked =
        option === activeOption &&
        quantity === optionQuantity;
    });

    if (!activeOption) {
      details.hidden = true;
      return;
    }

    const discount = Number(activeOption.dataset.discount) || 0;
    const unitPrice = Number(activeOption.dataset.unitPrice) || 0;

    if (discount <= 0 || unitPrice <= 0) {
      details.hidden = true;
      return;
    }

    const currentQuantity = quantity;
    const originalUnitPrice =
      unitPrice / (1 - discount / 100);

    const totalSaving = Math.round(
      (originalUnitPrice - unitPrice) * currentQuantity
    );

    const unitPriceElement =
      details.querySelector('[data-quantity-discount-unit-price]');

    if (unitPriceElement) {
      unitPriceElement.textContent =
        window.formatQuantityDiscountMoney
          ? window.formatQuantityDiscountMoney(unitPrice)
          : unitPrice;
    }

    const savingElement =
      details.querySelector('[data-quantity-discount-saving]');

    if (savingElement) {
      savingElement.textContent =
        window.formatQuantityDiscountMoney
          ? window.formatQuantityDiscountMoney(totalSaving)
          : totalSaving;
    }

    const savingWrapper =
      details.querySelector(
        '[data-quantity-discount-saving-wrapper]'
      );

    if (savingWrapper) {
      savingWrapper.hidden = totalSaving <= 0;
    }

    details.hidden = false;

    if (quantity > lastQuantity) {
      options.forEach(option => {
        option.checked = false;
      });
    }
  };

  const updateQuantityFromDiscountOption = option => {
    if (!option) return;

    const quantity = Number(option.dataset.quantity) || 0;
    if (!quantity) return;

    const quantityInput = getQuantityInput();
    if (!quantityInput) return;

    setQuantity(quantityInput, quantity);
    syncMainToSticky(quantity);
    updateQuantityDiscountSelection(quantityInput);

    lastQuantityInput = quantityInput;
    lastQuantity = quantity;
  };

  const syncQuantityDiscount = () => {
    const quantityInput = getQuantityInput();
    const stickyQuantityInput = getStickyQuantityInput();

    if (!quantityInput && !stickyQuantityInput) return;

    const currentQuantity = quantityInput ? Number(quantityInput.value) || 0 : null;
    const currentStickyQuantity = stickyQuantityInput ? Number(stickyQuantityInput.value) || 0 : null;
    const mainInputChanged = quantityInput !== lastQuantityInput;
    const mainQuantityChanged = currentQuantity !== lastQuantity;
    const stickyInputChanged = stickyQuantityInput !== lastStickyQuantityInput;
    const stickyQuantityChanged = currentStickyQuantity !== lastStickyQuantity;

    if (stickyInputChanged || stickyQuantityChanged) {
      lastStickyQuantityInput = stickyQuantityInput;
      lastStickyQuantity = currentStickyQuantity;

      if (stickyQuantityInput && currentQuantity !== currentStickyQuantity) {
        syncStickyToMain(currentStickyQuantity);
      }

      const currentQuantityInput = getQuantityInput();

      if (currentQuantityInput) {
        lastQuantityInput = currentQuantityInput;
        lastQuantity = Number(currentQuantityInput.value) || 0;

        updateQuantityDiscountSelection(currentQuantityInput);
      }

      return;
    }

    if (mainInputChanged || mainQuantityChanged) {
      lastQuantityInput = quantityInput;
      lastQuantity = currentQuantity;

      if (
        quantityInput &&
        currentStickyQuantity !== currentQuantity
      ) {
        syncMainToSticky(currentQuantity);
      }

      updateQuantityDiscountSelection(quantityInput);
    }
  };

  document.addEventListener('change', event => {

    const option = event.target.closest(OPTION_SELECTOR);
    if (option) {
      updateQuantityFromDiscountOption(option);
      return;
    }

    const stickyQuantityInput = event.target.closest(STICKY_QUANTITY_SELECTOR);

    if (stickyQuantityInput) {
      const quantity = Number(stickyQuantityInput.value) || 0;

      lastStickyQuantityInput = stickyQuantityInput;
      lastStickyQuantity = quantity;

      syncStickyToMain(quantity);

      const currentQuantityInput = getQuantityInput();

      if (currentQuantityInput) {
        lastQuantityInput = currentQuantityInput;
        lastQuantity = Number(currentQuantityInput.value) || 0;

        updateQuantityDiscountSelection(currentQuantityInput);
      }

      return;
    }

    const quantityInput = event.target.closest(QUANTITY_SELECTOR);

    if (quantityInput) {
      const quantity = Number(quantityInput.value) || 0;

      lastQuantityInput = quantityInput;
      lastQuantity = quantity;

      syncMainToSticky(quantity);
      updateQuantityDiscountSelection(quantityInput);
    }
  });

  document.addEventListener('input', event => {
    const stickyQuantityInput = event.target.closest(STICKY_QUANTITY_SELECTOR);

    if (stickyQuantityInput) {
      const quantity = Number(stickyQuantityInput.value) || 0;

      lastStickyQuantityInput = stickyQuantityInput;
      lastStickyQuantity = quantity;

      syncStickyToMain(quantity);

      const currentQuantityInput = getQuantityInput();

      if (currentQuantityInput) {
        lastQuantityInput = currentQuantityInput;
        lastQuantity = Number(currentQuantityInput.value) || 0;

        updateQuantityDiscountSelection(currentQuantityInput);
      }

      return;
    }

    const quantityInput = event.target.closest(QUANTITY_SELECTOR);

    if (!quantityInput) return;

    const quantity = Number(quantityInput.value) || 0;

    lastQuantityInput = quantityInput;
    lastQuantity = quantity;

    syncMainToSticky(quantity);
    updateQuantityDiscountSelection(quantityInput);
  });

  const observeSelectedVariant = variantSelects => {
    if (!variantSelects) return;

    const selectedVariantElement = variantSelects.querySelector('script[data-selected-variant]');
    if (!selectedVariantElement) return;

    let lastVariantJSON = selectedVariantElement.textContent.trim();
    const variantObserver = new MutationObserver(() => {
      const currentVariantJSON = selectedVariantElement.textContent.trim();
      if (currentVariantJSON === lastVariantJSON) return;

      lastVariantJSON = currentVariantJSON;
      updateQuantityDiscountPrices(variantSelects);
    });

    variantObserver.observe(selectedVariantElement, {
      childList: true,
      characterData: true,
      subtree: true
    });

    updateQuantityDiscountPrices(variantSelects);

    return variantObserver;
  };

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.('variant-selects')) {
          observeSelectedVariant(node);
          return;
        }

        node.querySelectorAll?.('variant-selects').forEach(variantSelects => {
          observeSelectedVariant(variantSelects);
        });
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setInterval(() => {
    syncQuantityDiscount();
  }, 100);

  syncQuantityDiscount();

  document.querySelectorAll('variant-selects').forEach(variantSelects => {
    observeSelectedVariant(variantSelects);
  });
})();